import { Component, OnInit, Input } from '@angular/core';
import { TabConfig } from './container.component.type';
import { RootComponent } from '../../root/root.component';

@Component({
  selector: 'nw-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent extends RootComponent implements OnInit {
  // TODO - Implement it later
  @Input()
  color: string;

  @Input()
  height: number;

  @Input()
  title: string;

  @Input()
  text: string;

  @Input()
  width: number;

  @Input()
  tabs: TabConfig[];

  selectedTab: TabConfig;
  clickedTab: TabConfig;

  selectedData;

  get style() {
    return {
      height: `${this.height || 300}px`,
      width: `${this.width || this.height || 300}px`,
    };
  }

  async ngOnInit() {
    this.selectedTab = this.tabs?.[0];
    if (this.selectedTab) {
      this.selectedData = await this.db.getSync(this.selectedTab.storeKey);
    }
    this.title = this.title || this.selectedTab?.title;
  }

  click(tab: TabConfig) {
    if (!!tab.subTabs?.length) {
      this.clickedTab = tab;
    } else {
      this.selectedTab = tab;
    }
  }

  async clickSubTab(event: Event, tab: TabConfig) {
    event.stopPropagation();
    this.selectedTab = tab;
    this.clickedTab = tab;
    this.selectedData = await this.db.getSync(tab.storeKey);
  }
}
